
const PRODUCT_A_ID = 9507669442901; // Kissen
const PRODUCT_B_ID = 10287761326421; // Bundle

(function () {
  // Optional: Nur auf der Cart Seite laufen lassen
  if (!window.location.pathname.includes("/cart")) {
    return;
  }

  let enforceTimeout = null;

  function setCartActionsDisabled(disabled) {
    const container = document.querySelector(".cart-actions");
    if (!container) return;

    const elements = container.querySelectorAll("button, input[type='submit'], a");

    elements.forEach((el) => {
      if (disabled) {
        if (!el.hasAttribute("data-original-disabled")) {
          el.setAttribute("data-original-disabled", el.disabled ? "true" : "false");
        }
        el.disabled = true;
        el.setAttribute("aria-disabled", "true");
      } else {
        const wasDisabled = el.getAttribute("data-original-disabled");
        if (wasDisabled === "false") {
          el.disabled = false;
          el.removeAttribute("aria-disabled");
        }
        el.removeAttribute("data-original-disabled");
      }
    });
  }

  function scheduleEnforceRelation() {
    if (enforceTimeout) {
      clearTimeout(enforceTimeout);
    }

    setCartActionsDisabled(true);

    enforceTimeout = setTimeout(enforceRelation, 400);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    });
    if (!res.ok) {
      throw new Error("Cart fetch failed");
    }
    return res.json();
  }

  async function changeLine(line, quantity) {
    const formData = new FormData();
    formData.append("line", String(line));
    formData.append("quantity", String(quantity));

    const res = await fetch("/cart/change.js", {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "application/json"
      }
    });

    if (!res.ok) {
      throw new Error("Cart change failed");
    }
    return res.json();
  }

  async function enforceRelation() {
    let didChange = false;

    try {
      const cart = await fetchCart();

      let qtyA = 0;
      let totalB = 0;

      cart.items.forEach((item) => {
        if (item.product_id === PRODUCT_A_ID) qtyA += item.quantity;
        if (item.product_id === PRODUCT_B_ID) totalB += item.quantity;
      });

      // Wenn A fehlt, B komplett löschen
      if (qtyA === 0 && totalB > 0) {
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          if (item.product_id === PRODUCT_B_ID) {
            await changeLine(i + 1, 0);
            didChange = true;
          }
        }

        if (didChange) {
          window.location.reload();
          return;
        } else {
          setCartActionsDisabled(false);
          return;
        }
      }

      // Wenn kein B im Warenkorb: freigeben
      if (totalB === 0) {
        setCartActionsDisabled(false);
        return;
      }

      // Wenn B <= A: freigeben
      if (totalB <= qtyA) {
        setCartActionsDisabled(false);
        return;
      }

      // Reduzieren, falls B > A
      let remainingAllowedForB = qtyA;

      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        if (item.product_id !== PRODUCT_B_ID) continue;

        const line = i + 1;
        const currentQty = item.quantity;

        let newQty = 0;

        if (remainingAllowedForB > 0) {
          newQty = Math.min(currentQty, remainingAllowedForB);
          remainingAllowedForB -= newQty;
        }

        if (newQty !== currentQty) {
          await changeLine(line, newQty);
          didChange = true;
        }
      }

      if (didChange) {
        window.location.reload();
        return;
      } else {
        setCartActionsDisabled(false);
      }
    } catch (err) {
      console.error("Error enforcing product relation", err);
      setCartActionsDisabled(false);
    }
  }

  // Listener für Änderungen
  document.addEventListener(
    "change",
    function (event) {
      const target = event.target;

      if (!target) return;

      if (
        target.matches('input[name="quantity"]') ||
        target.matches('input[name="updates[]"]') ||
        target.matches('input[data-quantity-input]')
      ) {
        scheduleEnforceRelation();
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      const target = event.target;

      if (!target) return;

      if (
        target.matches('[data-cart-remove]') ||
        target.matches('button[name="remove"]') ||
        target.matches('a[href*="change?line"]')
      ) {
        scheduleEnforceRelation();
      }
    },
    true
  );

  // Direkt beim Laden: Checkout blockieren + Check starten
  window.addEventListener("load", function () {
    setCartActionsDisabled(true);
    enforceRelation();
  });
})();
